import { api } from '../config/api'
import { defaultPageSize } from '../utils/constants'

const baseEndpoint = '/NotificationApi'
const accountEndpoint = '/AccountApi'

export const getNotifications = ({ pageNumber, pageSize = defaultPageSize, filters }) =>
  api.get(`${baseEndpoint}/Cards`, { params: { pageNumber, pageSize, ...filters } })

export const getHighlightNotification = () =>
  api.get(`${baseEndpoint}/Highlight`)

export const markNotificationsSeen = () =>
  api.put(`${accountEndpoint}/NotificationLastSeen`)
